import React, { useState } from "react";
import UIModal from "../UI/Modal";
import "./modal.css";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import YouTube from "react-youtube";

type ModalProps = {
  onClickClose?: any,
  videosPosVenda?: VideoAfterSales[] | null,
};
const VideoModal = ({ onClickClose, videosPosVenda }: ModalProps) => {
  const [scrollX, setScrollX] = useState(0);
  const [videoSelected, setVideoSelected] = useState(1);

  let videoModalWidth;
  const totalVideos = videosPosVenda.length;

  const handleLeftArrow = () => {
    if (videoSelected > 1) setVideoSelected(videoSelected - 1);
  };
  const handleRigthArrow = () => {
    if (videoSelected < totalVideos) setVideoSelected(videoSelected + 1);
  };

  return (
    <UIModal onClickClose={onClickClose}>
      <div className="VideoModal__content">
        <h2>Tutoriais</h2>
        <div className="VideoModal__MovieRow-left" onClick={handleLeftArrow}>
          <NavigateBeforeIcon style={{ fontSize: 40 }} />
        </div>
        <div className="VideoModal__MovieRow-right" onClick={handleRigthArrow}>
          <NavigateNextIcon style={{ fontSize: 40 }} />
        </div>
        <div
          className="VideoModal__MovieRow-listarea"
          style={{ width: totalVideos * videoModalWidth }}
        >
          <div className="VideoModal__MovieRow-list" style={{ marginLeft: scrollX }}>
            {videosPosVenda.map((videosPosVenda, key) => (
              <div
                className="VideoModal__MovieRow-item"
                key={key}
                style={{
                  display: videoSelected === videosPosVenda.id ? "block" : "none",
                }}
              >
                <YouTube videoId={videosPosVenda.videoUrl} />
                <div className="VideoModal__MovieRow-item-title">
                  Vídeo {videosPosVenda.id} de {totalVideos}: {videosPosVenda.videoTitle}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </UIModal>
  );
};
export default VideoModal;
